import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { LocalizationProvider } from '@mui/x-date-pickers';
import AppDateAdapter, { isUnreadablePaste } from '../utils/dateAdapter';

// A picker renders its date as sections inside this element.
const DATE_FIELD = '.MuiPickersSectionList-root';

// CREW-1286. A paste into a date field that is not a date is stopped here, in
// the capture phase on the document — before React, and so before MUI X, which
// would clear the field. The field keeps what it had. Every picker of the app
// lives under this provider, so this is the one place for it, next to the
// adapter that decides what a date is.
const stopUnreadablePaste = (event) => {
  if (!event.target?.closest?.(DATE_FIELD)) return;
  if (!isUnreadablePaste(event.clipboardData?.getData('text'))) return;

  event.preventDefault();
  event.stopImmediatePropagation();
};

// Wrapper around MUI X Pickers' LocalizationProvider — keeps the
// existing prop name `utils` for source-compat with the v3 API
// (`@material-ui/pickers`'s MuiPickersUtilsProvider had the same
// prop name). Passes through to the v6 `dateAdapter` slot.
// The default adapter reads a pasted date in the separators a CV uses, not
// only dd.MM.yyyy (CREW-1286, utils/dateAdapter.js).
const DateUtilsProvider = ({ children, utils = AppDateAdapter }) => {
  useEffect(() => {
    document.addEventListener('paste', stopUnreadablePaste, true);
    return () => document.removeEventListener('paste', stopUnreadablePaste, true);
  }, []);

  return (
    <LocalizationProvider dateAdapter={utils}>
      {children}
    </LocalizationProvider>
  );
};

DateUtilsProvider.propTypes = {
  children: PropTypes.any.isRequired,
  utils: PropTypes.any,
};

export default DateUtilsProvider;
